import {
    FETCH_COUNTRIES_START,
    FETCH_COUNTRIES_SUCCESS,
    FETCH_COUNTRIES_FAILURE,
  } from "../actions/ActionConstant";
  
  const initialState = {
    countries: {
      data: [],
      loading: true,
      error: false,
    },
  };
  
  const CountryReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_COUNTRIES_START:
        return {
          ...state,
          countries: {
            data:[],
            loading: true,
            error: false,
          },
        };
      case FETCH_COUNTRIES_SUCCESS:
        return {
          ...state,
          countries: {
            data: action.data,
            loading: false,
            error: false,
          },
        };
      case FETCH_COUNTRIES_FAILURE:
        return {
          ...state,
          countries: {
            data: [],
            loading: true,
            error: action.error
          },
        };
      default:
        return state;
    }
  };
  
  export default CountryReducer;
  
